export default __webpack_public_path__ + "static/squirrel-0-fae079053dec1bd94eff05973d075403.png";